import {
  AddOneSlotToLoadingQueue,
  RemoveOneSlotToLoadingQueue,
} from "../../loading/loading.store";

import Service from "../../../../api/api-service";
import { ApiUrl } from "../../../../api/api-url";
import ShowNotification from "../../../../components/react-notifications/react-notifications";
import { NotificationMessageType } from "../../../../utils/configuration";

const service = new Service();

export const FINISH_CREATE_OK = "FINISH_CREATE_OK";
export const FINISH_CREATE_ERR = "FINISH_CREATE_ERR";

export function finishCreateOk(payload) {
  return {
    type: FINISH_CREATE_OK,
    payload,
  };
}

export function finishCreateErr(payload) {
  return {
    type: FINISH_CREATE_ERR,
    payload,
  };
}

export const finishCreateService = {
  finishCreate,
};

function finishCreate(params) {
  return function (dispatch) {
    dispatch(AddOneSlotToLoadingQueue);
    return service
      .post(ApiUrl.EvaluateRecordsType_FinishCreate, params)
      .then((response) => {
        dispatch(finishCreateOk(response));
        dispatch(RemoveOneSlotToLoadingQueue);
      })
      .catch((error) => {
        dispatch(finishCreateErr(error));
        dispatch(RemoveOneSlotToLoadingQueue);
        ShowNotification(error.errorMessage, NotificationMessageType.Error);
      });
  };
}
